<template>
  <div class="pb9">
    <v-card>
      <v-card-text>
        <v-flex>
          <v-layout>
            <v-flex>
              <v-select :items="displayPeriodList" v-model="displayPeriod" label="Select period"></v-select>
            </v-flex>
          </v-layout>
          <v-calendar
            ref="calendar"
            :now="showDate"
            :value="calendarValue"
            :type="displayPeriod"
            :events="eventsData"
            @click:date="onClickDate"
            @moved="onMove"
            color="primary"
            class="theme-default"
          >
            <template v-slot:day="{ date }">
              <template v-for="event in eventsMap[date]">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <div
                      v-ripple
                      @click="onClickEvent(event)"
                      class="my-event"
                      :class="{ 'manager-class': isCaseManagerEqual(event),
                                'not-manager': !isCaseManagerEqual(event), 'first': event.firstEvent, 'last': event.lastEvent, 'mid': event.midEvent }"
                      v-html="event.time + ' ' + event.title"
                      v-on="on"
                    ></div>
                  </template>
                  <span v-html="event.title"></span>
                </v-tooltip>
              </template>
            </template>

            <template v-slot:dayBody="{ date, timeToY, minutesToPixels }">
              <template v-for="event in eventsMap[date]">
                <div
                  v-if="event.time"
                  :key="event.id"
                  :style="{ top: timeToY(event.time) + 'px', height: minutesToPixels(event.duration) + 'px' }"
                  class="my-event with-time"
                  :class="{ 'manager-class': isCaseManagerEqual(event),
                                'not-manager': !isCaseManagerEqual(event), 'first': event.firstEvent, 'last': event.lastEvent, 'mid': event.midEvent }"
                  @click="onClickEvent(event)"
                  v-html="event.title"
                ></div>
              </template>
            </template>
          </v-calendar>
          <v-flex
            md6
            xs12
            class="text-sm-left text-xs-center"
          >
            <v-btn @click="$refs.calendar.prev()">
              <v-icon dark left>keyboard_arrow_left</v-icon>
              Prev
            </v-btn>
            <v-btn @click="$refs.calendar.next()">
              Next
              <v-icon right dark>keyboard_arrow_right</v-icon>
            </v-btn>
          </v-flex>
        </v-flex>
      </v-card-text>
      <div class="legend-box case-manager"></div> – you assigned to this case
      <br><br>
      <div class="legend-box not-case-manager"></div> – you aren't assigned to this case
      <br><br>
    </v-card>
  </div>
</template>

<style scoped>
  .legend-box {
    margin: 0 5px 0 25px;
    width: 20px;
    height: 20px;
    border-radius: 3px;
    float: left;
  }
  .legend-box.case-manager {
    background-color: #00c853 !important;
  }
  .legend-box.not-case-manager {
    background-color: #0d47a1;
  }
</style>

<script>
  import schedulesAPI from '@/api/resources/schedules'
  import AddCaseNameAndDateDialog from '@/components/dialogs/AddCaseNameAndDateDialog'
  import IsMobile from '@/mixins/IsMobile'
  import AddScheduledCaseButton from '@/components/buttons/AddScheduledCaseButton'
  import _ from 'lodash'

  export default {
    components: { AddScheduledCaseButton, AddCaseNameAndDateDialog },
    mixins: [ IsMobile ],
    data () {
      return {
        todoCasesTableHeaders: [
          { text: 'Case ID', value: 'id' },
          { text: 'Case Name', value: 'name' },
          { text: 'Wake Start Date', value: 'wake_start' },
          { text: 'Wake End Date', value: 'wake_end' }
        ],
        displayPeriodList: [
          { text: 'Week', value: 'week' },
          { text: 'Month', value: 'month' }
        ],
        displayPeriod: 'week',
        periodCount: 1,
        todoCases: [],
        showDate: this.moment().format('YYYY-MM-DD'),
        calendarValue: this.moment().format('YYYY-MM-DD'),
        events: [],
        eventsRaw: [],
        eventsData: []
      }
    },
    computed: {
      isCaseManager () {
        return this.$store.getters.currentUserRoles.includes('case-manager')
      },
      isDispatcher () {
        return this.$store.getters.currentUserRoles.includes('dispatcher')
      },
      eventsMap () {
        const map = {}
        this.events.forEach(e => (map[e.date] = map[e.date] || []).push(e))
        return map
      }
    },
    provide: function () {
      return {
        onClickDate: this.onClickDate
      }
    },
    methods: {
      isCaseManagerEqual (event) {
        return event.case_manager === this.$store.getters.currentUser.id
      },
      loadSchedules () {
        schedulesAPI.loadSchedules().then(result => {
          console.log('result', result)
          this.eventsRaw = JSON.parse(JSON.stringify(result))
          this.events = this.normalizeForScheduleComponent(result)
        }, () => {})
      },
      onClickEvent (event) {
        if (this.$can('use', 'appointment-schedule-click-event')) {
          if (this.forCaseManager) {
            this.$router.push({ name: 'OnboardClient', params: { caseid: event.cases_id } })
          } else {
            this.$router.push({ name: 'NewLeads', params: { caseId: event.cases_id, editable: true } })
          }
        }
      },
      onClickDate (date) {
        if (this.$can('use', 'appointment-schedule-create-new-case')) {
          this.dateForNewLead = this.moment(date).subtract(1, 'month').format('YYYY-MM-DD')
        }
      },
      onMove (data) {
        this.calendarValue = data.date
      },
      onDrop (event, date) {
        let eLength = this.dayDiff(event.startDate, date)

        event.originalEvent.startDate = this.addDays(event.startDate, eLength)
        event.originalEvent.endDate = this.addDays(event.endDate, eLength)

        let dateStartObject = new Date(event.originalEvent.startDate)
        let dateEndObject = new Date(event.originalEvent.endDate)

        let dateStartFormatted = this.isoYearMonthDay(dateStartObject) + ' ' + this.formattedTime(dateStartObject, 'us-US')
        let dateEndFormatted = this.isoYearMonthDay(dateEndObject) + ' ' + this.formattedTime(dateEndObject, 'us-US')

        if (event.originalEvent.leads_id) {
          schedulesAPI.updateLeadWithDates(event.originalEvent.leads_id, dateStartFormatted, dateEndFormatted).then(() => {}, () => {})
        } else {
          schedulesAPI.updateScheduleWithDates(event.originalEvent.id, event.originalEvent.service.id, dateStartFormatted, dateEndFormatted).then(() => {}, () => {})
        }
      },
      selectEventColor (caseStatus) {
        switch (caseStatus) {
          case 'pending': return 'light-blue lighten-4'
          case 'filled': return 'light-green lighten-4'
          case 'closed':
            return 'purple accent-1'
          default: return 'light-blue lighten-4'
        }
      },
      normalizeForScheduleComponent: function (data) {
        let localData = JSON.parse(JSON.stringify(data))

        localData.forEach((item, i) => {
          let caseDataLabel = item.case && '\n\nCase #: ' + item.case.id + '\nCase Name: ' + item.case.name

          item.date = this.moment(item.schedule_start, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')
          item.time = this.moment(item.schedule_start, 'YYYY-MM-DD HH:mm:ss').format('HH:mm')
          item.endDate = this.moment(item.schedule_end, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')
          item.endDateTime = this.moment(item.schedule_end, 'YYYY-MM-DD HH:mm:ss').format('HH:mm')

          item.duration = this.moment
            .duration(this.moment(item.schedule_end, 'YYYY-MM-DD hh:mm:ss')
              .diff(this.moment(item.schedule_start, 'YYYY-MM-DD hh:mm:ss')))
            .asMinutes() || 60

          item.open = false

          item.title = 'Staff: \n'

          item.classes = item.case && this.selectEventColor(item.case.status)

          item.case_manager = null
          if (item.leads_id) {
            let filtered = this.eventsRaw.filter(filtering => filtering.leads_id === item.leads_id)

            item.title += filtered.map(mapping => mapping.service !== null ? mapping.service.description + ' ' + mapping.service.name : '') + '; ' + caseDataLabel

            let managerService = _.find(filtered, ['service.description', 'Case Manager'])
            if (managerService && managerService.service.users_id) {
              item.case_manager = managerService.service.users_id
            }

            let itemsWithSameLead = localData.filter(filtering => filtering.leads_id === item.leads_id && filtering.item_id !== item.item_id).map(mapping => mapping.item_id)

            if (itemsWithSameLead.length > 0) {
              itemsWithSameLead.forEach(sameItem => {
                let index = localData.findIndex(finding => finding.item_id === sameItem && finding.leads_id === item.leads_id)

                localData.splice(index, 1)
              })
            }
          } else {
            item.title += item.service.description + ' ' + item.service.name + ';' + caseDataLabel
          }
        })

        return localData
      },
      setShowDate (date) {
        this.showDate = date
      },
      loadCases () {
        // console.log('showDate', this.showDate)
        // console.log('calendarValue', this.calendarValue)
        // console.log('displayPeriod', this.displayPeriod)
        const apiUrl = this.$store.getters.config.api_host
        this.$axios.get(`${apiUrl}/api/cases/all`).then(response => {
          this.events = this.prepareDataForCalendar(response.data.additional_data)
          this.eventsData = this.prepareDataForCalendar(response.data.additional_data)
          console.log('response', response)
          console.log('events', this.eventsData)
          // TODO: сделать разбивку на дни, т.е. если кейс идет с 3 по 6, то он должен забиваться в 3, 4, 5 и 6
        })
      },
      prepareDataForCalendar (data) {
        return data.flatMap(i => {
          const start = this.moment(i.wake_start, 'YYYY-MM-DD HH:mm:ss')
          const end = this.moment(i.wake_end, 'YYYY-MM-DD HH:mm:ss')
          const width = end.diff(start, 'hours') / 24 * 100
          // If you want an inclusive end date (fully-closed interval)
          let days = []
          if (isNaN(end.diff(start, 'days'))) {
            const dayData = {
              id: i.id,
              name: `Case #${i.id}–${i.wake_start} till ${i.wake_end}`,
              title: `Case #${i.id}<br>Start: ${i.wake_start}<br>End: ${i.wake_end}`,
              date: start.format('YYYY-MM-DD'),
              time: this.moment(i.wake_start, 'YYYY-MM-DD HH:mm:ss').format('HH:mm'),
              start_date: this.moment(i.wake_start, 'YYYY-MM-DD HH:mm:ss'),
              end_date: this.moment(i.end_date, 'YYYY-MM-DD HH:mm:ss'),
              width: width,
              color: 'blue'
            }
            days.push(dayData)
          } else {
            let k = 1
            for (let day = this.moment(start); day.isBefore(end); day.add(1, 'days')) {
              const dayData = {
                id: i.id,
                name: `Case #${i.id}–${i.wake_start} till ${i.wake_end}`,
                title: k === 1 ? `Case #${i.id} <b>${i.wake_start}</b>&nbsp;&mdash;&nbsp;<b>${i.wake_end}</b>` : '',
                date: day.format('YYYY-MM-DD'),
                time: this.moment(i.wake_start, 'YYYY-MM-DD HH:mm:ss').format('HH:mm'),
                start_date: this.moment(i.wake_start, 'YYYY-MM-DD HH:mm:ss'),
                end_date: this.moment(i.end_date, 'YYYY-MM-DD HH:mm:ss'),
                width: width,
                color: 'blue',
                firstEvent: k === 1,
                lastEvent: day.format('YYYY-MM-DD') === this.moment(i.wake_end, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
                midEvent: k !== 1 && day.format('YYYY-MM-DD') !== this.moment(i.wake_end, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')
              }
              days.push(dayData)
              k++
            }
          }
          return days
          /*
          return i.wake_start && i.wake_end ? {
            id: i.id,
            name: `Case #${i.id}–${i.wake_start} till ${i.wake_end}`,
            title: `Case #${i.id}<br>Start: ${i.wake_start}<br>End: ${i.wake_end}`,
            date: this.moment(i.wake_start, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
            time: this.moment(i.wake_start, 'YYYY-MM-DD HH:mm:ss').format('HH:mm'),
            start_date: this.moment(i.wake_start, 'YYYY-MM-DD HH:mm:ss'),
            end_date: this.moment(i.end_date, 'YYYY-MM-DD HH:mm:ss'),
            width: width,
            color: 'blue'
          } : null
          */
        }).filter(i => i)
      }
    },
    created () {
      this.loadCases()
    },
    mounted () {
      if (this.DetectMobile()) {
        this.displayPeriod = 'day'
        this.$refs.calendar.scrollToTime('08:00')
      }
      this.isCaseManager ? this.displayPeriod = '4day' : null
      this.isDispatcher ? this.displayPeriod = 'day' : null
    },
    props: {
      forCaseManager: {
        type: Boolean,
        default: false,
        required: false
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .my-event {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 2px;
    color: #ffffff;
    font-size: 12px;
    padding: 3px;
    cursor: pointer;
    margin-bottom: 1px;
    left: 4px;
    margin-right: 8px;
    position: relative;

    min-height: 26px;

    &.with-time {
      position: absolute;
      right: 4px;
      margin-right: 0;
    }
    &.mid,
    &.last {
      text-indent: -9999px;
      content: '';
    }
    &.mid {
      left: 0;
      right: 0;
      border-radius: 0;
      margin-left: -1px;
      margin-right: -1px;
    }
    &.last {
      left: 0;
      border-radius: 0 2px 2px 0;
    }
    &.first {
      right: 0;
      border-radius: 2px 0 0 2px;
      z-index: 2;
      overflow: visible;
    }
  }
  .manager-class {
    background-color: #4CAF50;
    border: 1px solid #4CAF50;
  }
  .not-manager {
    background-color: #1867c0;
    border: 1px solid #1867c0;
  }
  .v-calendar.v-calendar-daily {
    display: block;
  }
</style>



// WEBPACK FOOTER //
// ViewCasesCalendar.vue?7de4f158